import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Shift, ShiftContainer, ShiftContainerRequest } from 'app/models/shift.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ShiftService {

    shift: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }

    getShift(companyId: number): Promise<Array<Shift>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "shifts/" + companyId)
                .subscribe((response: any) => {
                    this.shift = response;
                    this.onChanged.next(this.shift);
                    resolve(response);
                }, reject);
        });
    }
    getByShift(shiftId: number): Promise<Array<ShiftContainerRequest>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "shifts/getbyshift/" + shiftId)
                .subscribe((response: any) => {
                    this.shift = response;
                    this.onChanged.next(this.shift);
                    resolve(response);
                }, reject);
        });
    }

    getByCarImei(imei: string): Promise<Array<Shift>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "shifts/getbycarimei?imei=" + imei)
                .subscribe((response: any) => {
                    this.shift = response;
                    this.onChanged.next(this.shift);
                    resolve(response);
                }, reject);
        });
    }

    getContainerByShift(shiftId: number): Promise<Array<ShiftContainer>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "shifts/getcontainerbyshift/" + shiftId)
                .subscribe((response: any) => {
                    this.shift = response;
                    this.onChanged.next(this.shift);
                    resolve(response);
                }, reject);
        });
    }

    add(shift: Shift): Promise<Shift> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "shifts/add", shift)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    updated(shift: Shift): Promise<Shift> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "shifts/update", shift)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    updatedSingle(shift: Shift): Promise<Shift> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "shifts/updatesingle", shift)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    delete(shift: Shift): Promise<Shift> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "shifts/delete", shift)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

}
